/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Command } from './Command';
import {
    CommandFromJSON,
    CommandFromJSONTyped,
    CommandToJSON,
} from './Command';
import type { SortProperty } from './SortProperty';
import {
    SortPropertyFromJSON,
    SortPropertyFromJSONTyped,
    SortPropertyToJSON,
} from './SortProperty';

/**
 * 
 * @export
 * @interface Sorting
 */
export interface Sorting {
    /**
     * 
     * @type {Command}
     * @memberof Sorting
     */
    command?: Command;
    /**
     * 
     * @type {Array<SortProperty>}
     * @memberof Sorting
     */
    sortProperties: Array<SortProperty>;
}

/**
 * Check if a given object implements the Sorting interface.
 */
export function instanceOfSorting(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sortProperties" in value;

    return isInstance;
}

export function SortingFromJSON(json: any): Sorting {
    return SortingFromJSONTyped(json, false);
}

export function SortingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sorting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'command': !exists(json, 'command') ? undefined : CommandFromJSON(json['command']),
        'sortProperties': ((json['sortProperties'] as Array<any>).map(SortPropertyFromJSON)),
    };
}

export function SortingToJSON(value?: Sorting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'command': CommandToJSON(value.command),
        'sortProperties': ((value.sortProperties as Array<any>).map(SortPropertyToJSON)),
    };
}

